module.exports = __webpack_public_path__ + "static/media/MainPage_3.a0bf7d5d.png";